import type { FunctionComponent } from 'react';

import { ProgressCircleOutline } from './ProgressCircleOutline';

const radius = 5.2;
const strokeWidth = 1.5;
const circleLength = Math.PI * radius * 2;
const checkMarkPath =
    'M6.50013 8.83985C6.33276 9.00721 6.06141 9.00721 5.89404 8.83985L4.6634 7.6092C4.49603 7.44184 4.49603 7.17048 4.6634 7.00311L4.9004 6.76611C5.06776 6.59874 5.33912 6.59874 5.50649 6.76611L6.19709 7.45671L8.49357 5.16022C8.66094 4.99286 8.9323 4.99286 9.09966 5.16022L9.33666 5.39722C9.50403 5.56459 9.50403 5.83595 9.33666 6.00331L6.50013 8.83985Z';

export const ReviewProgressIcon: FunctionComponent<{
    readonly colorBase: string;
    readonly colorFill: string;
    readonly progress: number;
}> = ({ colorBase, colorFill, progress }) => {
    const dashLength = circleLength * progress;

    return (
        // biome-ignore lint/a11y/noSvgWithoutTitle: suppressed due to migration
        <svg fill="none" height="14" viewBox="0 0 14 14" width="14" xmlns="http://www.w3.org/2000/svg">
            <circle
                className="in-data-[is-active=true]:!stroke-text-on-accent"
                cx="7"
                cy="7"
                r={radius}
                stroke={colorBase}
                strokeWidth={strokeWidth}
            />
            <ProgressCircleOutline
                circleLength={circleLength}
                cx="7"
                cy="7"
                dashLength={dashLength}
                radius={radius}
                strokeWidth={strokeWidth}
                transform="rotate(-90 7 7)"
            />
            <circle
                className="in-data-[is-active=true]:!stroke-text-on-accent"
                cx="7"
                cy="7"
                r={radius}
                stroke={colorFill}
                strokeDasharray={`${dashLength} ${circleLength}`}
                strokeLinecap="round"
                strokeWidth={strokeWidth}
                transform="rotate(-90 7 7)"
            />
            <path
                className="in-data-[is-active=true]:!fill-text-on-accent"
                d={checkMarkPath}
                fill={progress > 0.5 ? colorFill : colorBase}
            />
        </svg>
    );
};
